/* ========================================================================
 *  module application help
 * ========================================================================
*/
FD.APPLICATIONHELP = (function ($, me) {
    'use strict';

    var child = me.PROJECTEDIT || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_COMMON = '/Common/Common/';

    var MESSAGE_CONTAINER_ELEM = '[data-modalmessage="true"]';
    var PARENT_ELEM = '[data-parent="true"]';
    var APP_INSTRUCTIONS = '#APP_INSTRUCTIONS';
    var APP_INSTRUCTIONS_CONTENT = '#APP_INSTRUCTIONS_CONTENT';
    var VIEW_INSTRUCTIONS = '#VIEW_INSTRUCTIONS';
    var MODAL_ELEM = '#APPLICATIONHELP_MODAL';

    var modal;
    var messageModalContainer = $(MESSAGE_CONTAINER_ELEM);
    var applicationID = -1;
    var viewID = -1;
    var videoList = [];

    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {
        SELECT_LANGUAGE: 1000
    };


    /* ========================================================================
     *  object functions
     * ========================================================================
    */
    
    
    
    //  load modal
    function getApplicationHelpModal() {
        if (me.getModalLock()) {
            return;
        }

        me.setModalLock(true);
        var options = {
            params: {
                applicationID: applicationID,
                viewID: viewID
            },
            url: URL_COMMON + 'GetApplicationHelpModal',
            callback: afterData,
            ishtml: true,
            cancelprevious: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;

            $('body').append(result);

            modal = $(MODAL_ELEM);

            modal.off().on('shown.bs.modal', function () {
                me.setToolTipDestroy();
                me.CONTROL.setSelect(true, MODAL_ELEM);
                $('.video-js').each(function () {
                    videoList.push(videojs(this, {
                        controls: true,
                        autoplay: false,
                        preload: 'auto'
                    }, function () {
                        this.removeClass('hidden');
                    }));
                })
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                $(MODAL_ELEM).remove();
                for (var x = 0; x < videoList.length; x++) {
                    videoList[x].dispose();
                }
            }).modal('show');

            messageModalContainer = $(MESSAGE_CONTAINER_ELEM);
            messageModalContainer = me.CONTROL.setMessageContainer(MESSAGE_CONTAINER_ELEM);
        }
    }


    // Get translation
    function getApplicationHelpTranslation(data) {
        var options = {
            params: {
                applicationID: applicationID,
                viewID: viewID,
                languageType: +data.value
            },
            url: URL_COMMON + 'GetApplicationHelpTranslation',
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            $(APP_INSTRUCTIONS_CONTENT).html(result.ApplicationInstructions.ApplicationHelpText);
            $(VIEW_INSTRUCTIONS).html(result.ViewInstructions.ApplicationHelpText);
        }
    }


    /* ========================================================================
     *  CRUD Functions
     * ========================================================================
    */
    



    /* ========================================================================
     *  page init
     * ========================================================================
    */


    child.init = function () { };
    
    child.getApplicationHelpModal = function (currentAppID, currentViewID) {
        applicationID = currentAppID;
        viewID = currentViewID;
        getApplicationHelpModal();
    };
    
    //   after control event
    child.getAfterControlEvent = function (data) {
        var result = data;

        switch (result.tag) {
            case tag.SELECT_LANGUAGE:
                getApplicationHelpTranslation(result);
                break;
        }
    };

    return child;
}(jQuery, FD));



